// extracted by mini-css-extract-plugin
export default {"main_role":"permissions_main_role__l+mIK"};